import { Collection } from 'modules/core/lib/mobx-rest'

import Projection from 'modules/reports/store/models/Projection'

class Projections extends Collection<Projection> {
  get cacheKey(): string {
    return 'projections'
  }

  model() {
    return Projection
  }
}

const singleton: Projections = new Projections()

export default singleton
